/** Simulates network latency for mock fetchers so loading states are visible. */
export const delay = (ms = 350) => new Promise<void>((resolve) => setTimeout(resolve, ms));
